const StaightKnifeIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="9.51611"
        y1="4.37114e-08"
        x2="9.51611"
        y2="44"
        stroke="white"
        stroke-width="2"
      />
      <line
        x1="35.7742"
        y1="4.37114e-08"
        x2="35.7742"
        y2="44"
        stroke="white"
        stroke-width="2"
      />
      <line y1="34.4834" x2="44" y2="34.4834" stroke="white" stroke-width="2" />
      <line y1="8.22559" x2="44" y2="8.22559" stroke="white" stroke-width="2" />
    </svg>
  );
};

export { StaightKnifeIcon };
